export default __webpack_public_path__ + "static/media/reliable-icon.06f36065.svg";